import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import './App.css';
import Contact from './components/Contact';
import MortgageCalculator from './components/MortgageCalculator';
import Home from './components/Home';
import Footer from './components/Footer';
import Blog from './components/Blog';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => {
      console.log("Toggling menu:", !prev); // Debug log
      return !prev;
    });
  };

  const closeMenu = () => {
    console.log("Closing menu"); // Debug log
    setMenuOpen(false);
  };

  return (
    <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>

      <div className="container">
        {/* Top Info Strip*/}
        <div className="top-strip">
          <span className="strip-span"> ✆ 801-340-9064</span>
          <span className="strip-span"> ✉ lauren@nexthomegps.com</span>
          <span className="strip-span"> Lic # 14253188</span>
          <span className="strip-span"> More Than Just an Agent—Your Trusted Partner and Counselor Through Every Real Estate Decision</span>
        </div>

        <header className="header">
          <img
            src="/main-logo.png"
            alt="Lauren Gresham - Nested By Lauren, Utah Real Estate Agent"
            className="logo"
          />

          {/* Hamburger Button */}
          <button className="hamburger" onClick={toggleMenu}>
            ☰
          </button>

          {/* Navigation Menu */}
          <nav className={menuOpen ? "nav open" : "nav"}>
            <ul>
              <li>
                <Link to="/" onClick={closeMenu}>
                  Home
                </Link>
              </li>
              <li>
                <Link to="https://lauren.mosergrouputah.com/" onClick={closeMenu}>
                  Find Homes
                </Link>
              </li>
              <li>
                <Link to="/contact" onClick={closeMenu}>
                  Contact Me
                </Link>
              </li>
            </ul>
          </nav>
        </header>

        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/mortgage-calculator" element={<MortgageCalculator />} />
            <Route path="/gallery" element={<Blog />} />
          </Routes>
        </main>

          {/* Footer */}
          <Footer />

      </div>
    </Router>
  );
}

export default App;
